import entity from './entity';

const TYPES = {
  ...entity.getTypes(),
};

export {
  TYPES,
};

export default {
  TYPES,
  ...entity.getActions(),
};
